import { generateTableResultChartInterpolationLineSeries } from "./curve";
import { generateTableResultChartDataSeries } from "./evaluation_points";
import { generateTableResultChartPointsOfInterestSeries } from "./data_points";
import { generateTableResultChartSeaTrialsSeries } from "./sea_trials_series";

export function _getChartOptionsForTableData(
  title, xAxisTitle, yAxisTitle, sketchData, data, dataOfInterest, xMin, xMax, pointFormat = null, seaTrialsData = null, name) {

  const maxSeaTrialsX = seaTrialsData ? Math.max(...seaTrialsData.flat().map((item) => item[0])) : null;

  const maxX = Math.max(maxSeaTrialsX, xMax);

  const chartOptions = {
    credits: {
      enabled: false,
    },
    time: {
      useUTC: true,
    },
    chart: {
      zoomType: "xy",
    },
    title: {
      text: title
    },
    annotations: [
      {
        labelOptions: {

          shape: "rect",
          verticalAlign: "top",
          align: "right",
          justify: false,
          crop: true,
          backgroundColor: "#FAFAFA",
          borderWidth: 0,
        },
        labels: [],
      },
    ],
    yAxis: {
      title: {
        text: yAxisTitle,
        align: "high",
      },
    },
    xAxis: {
      title: {
        text: xAxisTitle,
        align: "high",
      },
      crosshair: true,
      min: xMin,
      max: xMax//maxX,

    },
    exporting: {
      enabled: false,
    },
    legend: {
      layout: "horizontal",
      align: "right",
      verticalAlign: "top",
      floating: false,
    },
    series: [
      generateTableResultChartInterpolationLineSeries(sketchData, name, pointFormat),
      generateTableResultChartDataSeries(data, "Evaluation Points", pointFormat),
      generateTableResultChartPointsOfInterestSeries(dataOfInterest, "Data points", pointFormat),
    ],
  };

  if (seaTrialsData !== null) {

    const onLegendItemClick = function () {
      setTimeout(() => {
        const visibiltyStatusAfterClick = this.visible;
        this.chart.xAxis[0].setExtremes(
          xMin,
          visibiltyStatusAfterClick ? maxX : xMax
        );
      }, 0);
    };
    seaTrialsData.forEach((series, index) => {
      chartOptions.series.push(generateTableResultChartSeaTrialsSeries(series, `Sea trials ${index + 1}`, onLegendItemClick));
    });

  }

  return chartOptions;
}
